import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { NoCreditWarningDialogComponent } from './no-credit-warning-dialog.component';
var NoCreditWarningDialogService = /** @class */ (function () {
    function NoCreditWarningDialogService(matDialog) {
        this.matDialog = matDialog;
        this.defaultConfigs = {
            width: '600px',
            disableClose: true
        };
    }
    /**
     * Shows no credit warning dialog
     * @method showNoCreditWarning
     */
    NoCreditWarningDialogService.prototype.showNoCreditWarning = function (dialogData) {
        var matDialog = this.matDialog.open(NoCreditWarningDialogComponent, tslib_1.__assign({}, this.defaultConfigs, { data: dialogData }));
        return matDialog.componentInstance.dialogAction;
    };
    return NoCreditWarningDialogService;
}());
export { NoCreditWarningDialogService };
